var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1177({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.68,4.59a3,3,0,0,0,.17-.95,3,3,0,0,0-5.94,0,3,3,0,0,0,.17.95,3,3,0,0,0,.45,5.88h2.1V7.76a2.83,2.83,0,0,0-2.72-.44.25.25,0,0,1-.33-.14.26.26,0,0,1,.15-.33,3.45,3.45,0,0,1,2.9.28V2.71a.25.25,0,0,1,.5,0V8.55a3.26,3.26,0,0,0,2.54-1.39.25.25,0,0,1,.43.25,3.67,3.67,0,0,1-3,1.64v1.42H10.2a3,3,0,0,0,.48-5.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.63,14.75a.25.25,0,0,0,.5,0V10.47h-.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1177);
export default __webpack_public_path__ + "static/media/Symbolpack_1_177.aeb036eed3c3ccfc1e32f30aaf307162.svg";
export { ForwardRef as ReactComponent };